import React from 'react';
import './Button.css';

type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost' | 'accent';
type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: ButtonVariant;
    size?: ButtonSize;
    fullWidth?: boolean;
}

const Button: React.FC<ButtonProps> = ({
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    type = 'button',
    className,
    children,
    ...props
}) => {
    const classes = ['ui-button', `ui-button-variant-${variant}`, `ui-button-size-${size}`, fullWidth ? 'ui-button-full-width' : '', className ?? '']
        .filter(Boolean)
        .join(' ');

    return (
        <button {...props} type={type} className={classes}>
            {children}
        </button>
    );
};

export default Button;
